<template>
  <div class="main">
    <report-top></report-top>
    <div id="formTable">
      <div class="formTableItem">
        <p class="label">表单模板列表，选择相应地表单填写即可发起流程</p>
      </div>
    </div>
    <div id="formmodel">
      <div class="formmodel" v-for="(x, index) in tableData" :key="index">
        <h3>{{ x.name }}</h3>
        <p>
          <Button
            @click="open(x)"
            size="small"
            type="primary"
            style="margin-right: 4px"
            >新增派单</Button
          ><Button size="small" @click="openList(x)">历史列表</Button>
        </p>
      </div>
    </div>
    <richangbaojie ref="richangbaojie"></richangbaojie>
    <xiaoxiuzuoye ref="xiaoxiuzuoye"></xiaoxiuzuoye>
    <gaoweizuoye ref="gaoweizuoye"></gaoweizuoye>
    <formList ref="formList"></formList>
  </div>
</template>
<script>
import richangbaojie from "./forms/richangbaojie.vue";
import xiaoxiuzuoye from "./forms/xiaoxiuzuoye.vue";
import gaoweizuoye from "./forms/gaoweizuoye.vue";
import formList from "./forms/formList.vue";
export default {
  components: { richangbaojie, formList, xiaoxiuzuoye,gaoweizuoye },
  data() {
    return {
      openForm: false,
      tableData: [],
      item: {},
    };
  },
  methods: {
    getFormList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.flow + "/form/list",
        data: {},
      }).then((res) => {
        console.log(res);
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        this.tableData = data;
      });
    },
    open(x) {
      console.log(x);
      this.$refs[x.field].reach(x);
    },
    openList(x) {
      this.$refs.formList.reach(x);
    },
  },
  mounted() {
    this.getFormList();
  },
  created() {},
};
</script>
<style>
#formmodel {
  display: flex;
  padding: 15px;
  padding-top: 0;
}
#formmodel .formmodel {
  background: white;
  width: 240px;
  padding: 15px;
  margin-right: 20px;
  box-shadow: 4px 4px 10px #ccc;
}
#formmodel .formmodel h3 {
  font-size: 18px;
  margin-bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/yhgl/wodepaidan.vue